import React,{ ChangeEventHandler, HTMLAttributes } from 'react';
import styles from './input.module.scss';


export function Input(props) {
  const {
    name,
    placeholder,
    label,
    onChange,
    onFocus,
    value,
    maxLength,
    className,
    type,
    error,
    inputMode,
    autoFocus,
    disabled,
    customStyle,
  } = props;

  return (
    <div className={styles['container']}>
      <div className={[styles['input-container'], className].join(' ')}>
        <label htmlFor={name}>{label}</label>
        <input
          id={name}
          name={name}
          type={type}
          onChange={onChange}
          onFocus={onFocus}
          placeholder={placeholder}
          maxLength={maxLength}
          value={value}
          autoComplete="off"
          inputMode={inputMode}
          autoFocus={autoFocus}
          disabled={disabled}
          style={customStyle}
        />
      </div>
      {error && <p>{error}</p>}
    </div>
  );
}
